import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type TrainingRequestDTO = {
    companyName: string;
    industry: string;
    isTrainingNeeded?: boolean;
    areaOfTraining: string;
    numberOfEmployees: string;
    expectedBudget: string;
    contactPerson: string;
    email: string;
    phone: string;
    additionalNote?: string;
 };
type TrainingRequestResponse = {
    data: object;
} & ApiError;
export const CreateTraining = (
    data: TrainingRequestDTO
): Promise<TrainingRequestResponse> => {
    return axios.post("/training/create", data);
};
